import {
  faCalendarDays,
  faFileContract,
  faFileInvoice,
  faListCheck,
  faUserGraduate
} from '@fortawesome/pro-solid-svg-icons'
import type { DashboardBlock } from './types'

export const defaultBlocks: DashboardBlock[] = [
  {
    id: 'last-applications',
    type: 'last-applications',
    title: 'Dernières candidatures',
    icon: faUserGraduate,
    isVisible: true,
    position: 1
  },
  {
    id: 'next-actions',
    type: 'next-actions',
    title: 'Actions prévues',
    icon: faListCheck,
    isVisible: true,
    position: 2
  },
  {
    id: 'calendar',
    type: 'calendar',
    title: 'Agenda',
    icon: faCalendarDays,
    isVisible: true,
    position: 3
  },
  {
    id: 'applicant-experiences',
    type: 'applicant-experiences',
    title: 'Contrats à renouveler',
    icon: faFileContract,
    isVisible: true,
    position: 4
  },
  {
    id: 'last-open-orders',
    type: 'last-open-orders',
    title: 'Dernières commandes ouvertes',
    icon: faFileInvoice,
    isVisible: true,
    position: 5
  }
]
